// extracted by mini-css-extract-plugin
module.exports = {"title":"LogoutModal_title__vM80j","modalBody":"LogoutModal_modalBody__3ryqk","modalFooter":"LogoutModal_modalFooter__XoFJl","logoutButton":"LogoutModal_logoutButton__1u2kM"};